import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {DispatchService} from '../../core/services/dispatch.service';
import {PickingService} from '../../core/services/picking.service';
import { TenantInterface } from 'src/models/Tenant';
import { TenantService } from 'src/app/core/services/tenant.service';
import { DashboardDatasourceService } from 'src/app/core/data-sources/v3/dashboard/dashboard-datasource.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  inValues = {
    created: '-',
    receiving: '-',
    finished: '-'
  };
  pickingValues = {
    outOrders: 0,
    outOrdersInSeparation: 0,
    outOrdersWithExecutionPlan: 0
  };
  stockValues = {
    inspection: '-',
    issuedInvoices: '-',
    stock: '-',
    exit: '-'
  };
  outValues = {
    dispatching: '-',
    finalized: '-',
    issuedInvoices: '-'
  };

  isLoading: boolean;
  tenant: TenantInterface;

  constructor(
    private router: Router,
    private pickingService: PickingService,
    private dispatchService: DispatchService,
    private tenantService: TenantService,
    private dashboardDatasourceService: DashboardDatasourceService
  ) { }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;

    try {
      this.tenant = await this.tenantService.get();
      await Promise.all([
        this.getIn(),
        this.getOut(),
        this.getPicking(),
        this.getInspection(),
        this.getExit(),
        this.getStock()
      ]);
    } catch (err) {
      console.log(err);
    } finally {
      this.isLoading = false;
    }
  }

  getStock(){
    if (!this.tenant?.process.stock) return;
    return this.dashboardDatasourceService.getStorageCount({ groundPositionType: ["STOCK"] }).toPromise().then(values => {
      this.stockValues.stock = values.count?.toString() || '0';
    });
  }

  getExit() {
    if (!this.tenant?.process.stock) return;
    return this.dashboardDatasourceService.getStorageCount({ groundPositionType: ["EXIT", "EXPEDITION"] }).toPromise().then(values => {
      this.stockValues.exit = values.count?.toString() || '0';
    });
  }

  getInspection() {
    if (!this.tenant?.process.stock) return;
    return this.dashboardDatasourceService.getStorageCount({ state: ["RECEIVED", "AWAITING_STORAGE"] }).toPromise().then(values => {
      this.stockValues.inspection = values.count?.toString() || '0';
    });
  }
  getPicking(){
    if (!this.tenant?.process.packing) return;
    return this.pickingService.getDocuments().then(values => {
      this.pickingValues.outOrders = values.outOrders.length;
      this.pickingValues.outOrdersInSeparation = values.outOrdersInSeparation.length;
      this.pickingValues.outOrdersWithExecutionPlan = values?.outOrdersWithExecutionPlan?.length;
    });
  }
  getIn(){
    if (!this.tenant?.process.in) return;
    this.dashboardDatasourceService.getInOrdersCount({ state: ["RECEIVING"] }).toPromise().then(values => {
      this.inValues.receiving = values.count?.toString() || '0';
    });
    this.dashboardDatasourceService.getInOrdersCount({ state: ["CREATED"] }).toPromise().then(values => {
      this.inValues.created = values.count?.toString() || '0';
    });
    this.dashboardDatasourceService.getInOrdersCount({ state: ["FINISHED"] }).toPromise().then(values => {
      this.inValues.finished = values.count?.toString() || '0';
    });
  }
  getOut(){
    if (!this.tenant?.process.out) return;
    return this.dispatchService.getDocuments().then(values => {
      this.outValues.dispatching = values.dispatching.length;
      this.outValues.finalized = values.finalized.length;
      this.outValues.issuedInvoices = values.issuedInvoices.length;

    });
  }

  async toEnterDocsAndScreening() {
    await this.router.navigate(['/in']);
  }
  async toStock() {
    await this.router.navigate(['/stock']);
  }
  async toInspection() {
    await this.router.navigate(['/inspection']);
  }
  async toPicking() {
    await this.router.navigate(['/picking']);
  }
  async toDispatch() {
    await this.router.navigate(['/dispatch']);
  }
  async toExit() {
    await this.router.navigate(['/exit'])
  }
  async toSellOrdersPage() {
    await this.router.navigate(['/sell-orders']);
  }
}
